import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-eclass', {
  key: 'admin-eclass',
  label: 'E-Class',
  getSteps: () => [
    introStep({
      title: 'E-Class',
      content:
        '"Subject Resources" is your shared library — notes, slides, links — for each subject. "Upload new material" is the form to add to it. "Create Class" sets up an online class session students can join.',
    }),
  ],
});
